module.exports = __webpack_public_path__ + "static/media/Byron Keelin Headshot.95b02a90.jpeg";